import apiClient from 'api/base';

export const addFavouriteTask = async (taskId: string): Promise<void> => {
  await apiClient.post('/favouriteTasks', { taskId });
};

export const removeFavouriteTask = async (taskId: string): Promise<void> => {
  await apiClient.delete(`/favouriteTasks/${taskId}`);
};

export const addFavouriteBroadcast = async (
  broadcastId: string,
): Promise<void> => {
  await apiClient.post('/favouriteBroadcasts', { broadcastId });
};

export const removeFavouriteBroadcast = async (
  broadcastId: string,
): Promise<void> => {
  await apiClient.delete(`/favouriteBroadcasts/${broadcastId}`);
};
